import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Customers from "./Components/Pages/Customers/Customers";
import Leads from "./Components/Pages/Leads/Leads";
import Calendar from "./Components/Pages/Calendar/Calendar";
import ViewCustomer from "./Components/Pages/Customers/ViewCustomer";
import AddCustomer from "./Components/Pages/Customers/AddCustomer";

import AddLead from "./Components/Pages/Leads/AddLead";
import Dashboard from "./Components/Pages/Dashboard/Dashboard";
// import LeadsReport from "./Components/Pages/Reports/LeadsReports";
// import CustomersReport from "./Components/Pages/Reports/CustomersReport";
// import RemindersReport from "./Components/Pages/Reports/RemindersReport";
import Login from "./Components/Pages/Login/Login";
import Products from "./Components/Pages/Products/Products";
import AddProdcut from "./Components/Pages/Products/AddProduct";
import Invoice from "./Components/Pages/Invoice/Invoices";
import AddInvoice from "./Components/Pages/Invoice/AddInvoice";
import Expenses from "./Components/Pages/Expenses/Expenses";
import AddExpense from "./Components/Pages/Expenses/AddExpense";
import EditExpense from "./Components/Pages/Expenses/EditExpense";
import ViewExpense from "./Components/Pages/Expenses/ViewExpenses";
import Tasks from "./Components/Pages/Tasks/Tasks";
import EditTask from "./Components/Pages/Tasks/EditTask";
import ViewTask from "./Components/Pages/Tasks/ViewTask";
import AddTask from "./Components/Pages/Tasks/AddTask";
import Payments from "./Components/Pages/Payments/Payments";
import EditPayment from "./Components/Pages/Payments/EditPayment";
import ViewPayment from "./Components/Pages/Payments/ViewPaymnet";
import EditInvoice from "./Components/Pages/Invoice/EditInvoice";
import ViewInvoice from "./Components/Pages/Invoice/ViewInvoice";
import Proposal from "./Components/Pages/proposals/proposal";
import AddProposal from "./Components/Pages/proposals/AddProposal";
import EditProposal from "./Components/Pages/proposals/editproposal";
import ViewProposal from "./Components/Pages/proposals/viewproposal";

import Note from "./Components/Pages/Customers/Note";
import LeadNotes from "./Components/Pages/Leads/LeadNotes";
import ToDo from "./Components/Pages/ToDo/ToDo";
import AddEstimate from "./Components/Pages/Estimates/AddEstimate";
import Estimates from "./Components/Pages/Estimates/Estimates";
import Reminders from "./Components/Pages/Reminders/Reminders";
import ViewEstimate from "./Components/Pages/Estimates/ViewEstimate";
import Credit from "./Components/Pages/Credites/Credit";
import AddCredit from "./Components/Pages/Credites/AddCredit";
import AddPayments from "./Components/Pages/Payments/AddPayments";
import ViewLead from "./Components/Pages/Leads/ViewLead";
import Notify from "./Components/Pages/Notifications/Notify";
import Settings from "./Components/Pages/Settings/Settings";
import VisitNotes from "./Components/Pages/VisitNotes/VisitNotes";
import Reports from "./Components/Pages/Reports/Reports";
import MyVisits from "./Components/Pages/VisitNotes/MyVisits";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="dashboard" element={<Dashboard />} />

          <Route path="products" element={<Products />} />
          <Route path="add-product" element={<AddProdcut />} />

          <Route path="expenses" element={<Expenses />} />
          <Route path="add-expense" element={<AddExpense />} />
          <Route path="edit-expense" element={<EditExpense />} />
          <Route path="view-expense" element={<ViewExpense />} />

          <Route path="customers" element={<Customers />} />
          <Route path="add-customer" element={<AddCustomer />} />
          <Route path="view-customer" element={<ViewCustomer />} />

          <Route path="Note" element={<Note />} />

          <Route path="invoice" element={<Invoice />} />
          <Route path="add-invoice" element={<AddInvoice />} />
          <Route path="edit-invoice" element={<EditInvoice />} />
          <Route path="view-invoice" element={<ViewInvoice></ViewInvoice>} />

          <Route path="proposal" element={<Proposal></Proposal>} />
          <Route path="add-proposal" element={<AddProposal></AddProposal>} />
          <Route path="edit-proposal" element={<EditProposal></EditProposal>} />
          <Route path="view-proposal" element={<ViewProposal></ViewProposal>} />

          <Route path="leads" element={<Leads />} />

          <Route path="add-lead" element={<AddLead />} />
          {/* <Route path="view-lead/:id" element={<ViewLead />} /> */}
          {/* <Route path="/view-lead" element={<ViewLead />} /> */}

          <Route path="/view-lead/:id" element={<ViewLead />} />
          <Route path="LeadNotes" element={<LeadNotes />} />

          <Route path="todo" element={<ToDo />} />

          <Route path="calendar" element={<Calendar />} />

          {/* <Route path="leads-report" element={<LeadsReport />} />
          <Route path="customers-report" element={<CustomersReport />} />
          <Route path="reminders-report" element={<RemindersReport />} /> */}
          <Route path="payments" element={<Payments />} />
          <Route path="edit-payment/:PaymentId" element={<EditPayment />} />
          <Route path="view-payment/:PaymentId" element={<ViewPayment />} />
          <Route path="AddPayment" element={<AddPayments />} />

          <Route path="tasks" element={<Tasks />} />
          <Route path="add-task" element={<AddTask />} />
          <Route path="edit-task" element={<EditTask />} />
          <Route path="view-task" element={<ViewTask />} />

          <Route path="addEstimate" element={<AddEstimate />} />
          <Route path="estimates" element={<Estimates />} />
          <Route path="view-estimate" element={<ViewEstimate />} />

          <Route path="reminders" element={<Reminders />} />

          <Route path="credits" element={<Credit />} />
          <Route path="addcredit" element={<AddCredit />} />

          <Route path="notifications" element={<Notify />} />
          <Route path="settings" element={<Settings />} />
          <Route path="VisitNotes" element={<VisitNotes />} />
          <Route path="MyVisits" element={<MyVisits />} />
          <Route path="Reports/:reportId" element={<Reports />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
